export const parseDateUtc = (dateStr?: string | null): Date | null => {
  if (!dateStr) return null;

  try {
    // YYYY-MM-DD format
    if (dateStr.includes('-') && dateStr.split('-').length === 3) {
      const [year, month, day] = dateStr.split('-').map((part) => parseInt(part));
      return new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
    }

    // MM/DD/YYYY format
    if (dateStr.includes('/') && dateStr.split('/').length === 3) {
      const [month, day, year] = dateStr.split('/').map((part) => parseInt(part));
      return new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
    }

    // other formats
    const date = new Date(dateStr);
    if (!isNaN(date.getTime())) {
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0));
    }

    return null;
  } catch (e) {
    console.error('Error parsing date:', e, dateStr);
    return null;
  }
};
